import { render, staticRenderFns } from "./GlobalListPage.vue?vue&type=template&id=b815fd26"
import script from "./GlobalListPage.vue?vue&type=script&lang=js"
export * from "./GlobalListPage.vue?vue&type=script&lang=js"
import style0 from "./GlobalListPage.vue?vue&type=style&index=0&id=b815fd26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports